<template>
    <div>
        <div>
            <van-popup
                @closed="closeModel"
                @close="closeModel"
                :close-on-popstate="true"
                v-model="drawerEdit"
                :close-on-click-overlay="false" 
                position="bottom"
            >
                <div>
                    <div class="search-title">
                        <div class="tle">设定商品盘点数量</div>
                        <van-icon @click="closeModel" name="cross" />
                    </div>
                    <div class="sku-header">
                        <div class="sku-header__img-wrap">
                            <van-image
                                fit="cover"
                                :src="goodMsg.img"
                                style="width:100%;height:100%"
                            />
                        </div>
                        <div class="sku-header__goods-info">
                            <div class="sku-header-item-name">
                                {{goodMsg.name}}
                            </div>
                            <div class="sku-header-item-code">
                                {{goodMsg.code}}
                            </div>
                            <div class="sku-header-item-unit">
                                {{goodMsg.goodsSpec?goodMsg.goodsSpec:'无规格'}}/{{goodMsg.unit}}
                            </div>
                        </div>
                    </div>
                    <div class="sku-body">
                        <div class="sku-opt">
                            <div class="sku-body-title">
                                订货数量
                            </div>
                            <div class="sku-body-value">
                                {{goodMsg.count}}
                            </div>
                            <div class="sku-body-line"></div>
                        </div>
                    </div>
                    <div>
                        <qwKeyWord :value="goodMsg.count" @change="changeValue"></qwKeyWord>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import qwKeyWord from '../../components/QWKeyWord/index'
export default {
    name: 'QianweiApputilsFrontendIndex',
    components:{
        qwKeyWord
    },
    data() {
        return {
            drawerEdit:false,
            goodMsg:{},
        };
    },

    mounted() {
        
    },

    methods: {
        onInput(value) {},
        onDelete() {},
        changeValue(res){
            if(res == 'enter'){
                this.closeSelect();
            }else{
                this.goodMsg.count = res
            }
        },
        open(item){
            this.goodMsg = JSON.parse(JSON.stringify(item))
            if(!this.goodMsg.count){
                this.$set(this.goodMsg,'count',0)
            }
            this.$forceUpdate();
            this.drawerEdit = true
        },
        closeSelect(){
            this.$emit('close',this.goodMsg)
            this.drawerEdit = false
        },
        closeModel(){
            this.$emit('close','')
            this.drawerEdit = false
        }
    },
};
</script>

<style scoped>
    .search-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color:#888;
        padding:10px;
        border-bottom:1px solid #ddd
    }
    .search-title .tle{
        font-size:15px;
    }
    .search-title .van-icon{
        font-size:20px;
    }
    .sku-header{
        position: relative;
        display: flex;
        margin:0 15px;
        border-bottom: 1px solid #f6f6f6;
    }
    .sku-header__img-wrap{
        width: 80px;
        height: 80px;
        margin: 12px 12px 12px 0;
        overflow: hidden;
        border-radius: 4px;
    }
    .sku-header__goods-info{
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-pack: end;
        justify-content: flex-end;
        padding: 12px 20px 12px 0;
    }
    .sku-header-item-name{
        margin-bottom: 8px;
        color:#555;
        font-size: 15px;
    }
    .sku-header-item-code{
        margin-bottom: 8px;
        color:#888;
        font-size: 13px;
    }
    .sku-header-item-unit{
        margin-bottom: 8px;
        color:#888;
        font-size: 13px;
    }
    .sku-body{
        margin:0 15px;
        display: flex;
        justify-content: space-between;
        padding:10px 0;
    }
    .sku-opt{
        width:32%
    }
    .sku-body-title{
        font-size:12px;
        color:#888
    }
    .sku-body-value{
        height:40px;
        line-height: 40px;
        font-size:16px;
        width: 100%;
        overflow-x: auto;
        color:#486ad8
    }
    .sku-body-line{
        width: 100%;
        height:2px;
        background:#486ad8
    }
</style>


// WEBPACK FOOTER //
// src/views/supplierOrder/editGoodMsg.vue